import { Widget } from "@/utils/widgets";
import { create } from "zustand";

export interface PopoutWidget extends Widget {
  widgetCompositeId?: string;
}

interface PopoutWidgetsStoreState {
  widgets: PopoutWidget[];

  addWidget: (widget: PopoutWidget) => void;
  removeWidget: (id: string) => void;
  toggleWidget: (id: string) => void;
  updateWidget: (id: string, updates: Partial<PopoutWidget>) => void;
}

export const usePopoutWidgetsStore = create<PopoutWidgetsStoreState>((set) => ({
  widgets: [],

  // Adds a new widget if it does not already exist
  addWidget: (widget) =>
    set((state) => {
      const exists = state.widgets.some((w) => w.id === widget.id);
      if (exists) {
        return state; // Do not add duplicate
      }
      return {
        widgets: [...state.widgets, widget],
      };
    }),

  // Removes a widget by its id
  removeWidget: (id) =>
    set((state) => ({
      widgets: state.widgets.filter((w) => w.id !== id),
    })),

  // Toggles a widget: removes it if it exists, no-op otherwise
  toggleWidget: (id) =>
    set((state) => {
      const exists = state.widgets.some((w) => w.id === id);
      return exists
        ? { widgets: state.widgets.filter((w) => w.id !== id) }
        : state;
    }),

  // Updates a widget by its id
  updateWidget: (id, updates) =>
    set((state) => ({
      widgets: state.widgets.map((w) =>
        w.id === id ? { ...w, ...updates } : w
      ),
    })),
}));
